import { ColorOptions, TextInput as UiTextInput, TextInputNew as UiTextInputNew } from '@jfs/ui-new'
import { ComponentProps, FC, forwardRef } from 'react'

/**
 * Drop-in replacements for the @jfs/ui-new TextInput / TextInputNew (admin-portal only).
 * Every field label uses one style: 12px, jiotype-medium, regular weight, #757575.
 * Error messages keep the library style (12px, ERROR red), which the dropdowns now match.
 */

export const FIELD_LABEL_STYLE = {
  fontSize: 12,
  fontFamily: 'jiotype-medium',
  fontWeight: '400',
  color: '#757575' as ColorOptions,
} as const

export const FIELD_ERROR_STYLE = {
  type: 'body12',
  fontFamily: 'jiotype-medium',
  color: 'ERROR' as ColorOptions,
} as const

type TextInputNewProps = ComponentProps<typeof UiTextInputNew>

export const TextInputNew: FC<TextInputNewProps> = forwardRef<any, TextInputNewProps>((props, ref) => (
  <UiTextInputNew
    {...props}
    {...({ ref } as any)}
    labelFontSize={FIELD_LABEL_STYLE.fontSize}
    labelFontFamily={FIELD_LABEL_STYLE.fontFamily}
    labelColor={FIELD_LABEL_STYLE.color}
  />
)) as any

type TextInputProps = ComponentProps<typeof UiTextInput>

export const TextInput: FC<TextInputProps> = forwardRef<any, TextInputProps>((props, ref) => (
  <UiTextInput {...props} {...({ ref } as any)} lableFontWeight={FIELD_LABEL_STYLE.fontWeight} />
)) as any
